var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup491(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 391,
    viewBox: "0 0 169 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 318.5,
    width: 70,
    height: 112,
    rx: 4,
    transform: "rotate(90 139.5 318.5)",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7634 343.169C92.2778 344.313 93.5069 345.798 94.3534 347.504C95.1999 349.211 95.6406 351.092 95.6406 353C95.6406 354.908 95.1999 356.789 94.3534 358.496C93.5069 360.202 92.2778 361.687 90.7634 362.831M97.3477 335.795C99.8935 337.869 101.947 340.49 103.357 343.467C104.768 346.444 105.5 349.701 105.5 353C105.5 356.299 104.768 359.556 103.357 362.533C101.947 365.51 99.8935 368.131 97.3477 370.205M68.816 360.374H63.9388C63.2921 360.374 62.6718 360.115 62.2145 359.654C61.7572 359.193 61.5002 358.568 61.5002 357.916V348.084C61.5002 347.432 61.7572 346.807 62.2145 346.346C62.6718 345.885 63.2921 345.626 63.9388 345.626H68.816L77.3511 334.566C77.5643 334.149 77.9185 333.822 78.3497 333.645C78.781 333.468 79.2608 333.452 79.7026 333.601C80.1443 333.749 80.5188 334.052 80.7584 334.455C80.998 334.857 81.0869 335.332 81.009 335.795V370.205C81.0869 370.668 80.998 371.143 80.7584 371.545C80.5188 371.948 80.1443 372.251 79.7026 372.399C79.2608 372.548 78.781 372.532 78.3497 372.355C77.9185 372.178 77.5643 371.851 77.3511 371.434L68.816 360.374Z",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6625 295V141M134.75 192.333L117.368 226.744L81.6625 141L37.75 260.59",
    stroke: "#D6AF66",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.75 100.003C61.75 105.573 63.9625 110.914 67.9007 114.852C71.839 118.791 77.1805 121.003 82.75 121.003C88.3195 121.003 93.661 118.791 97.5993 114.852C101.538 110.914 103.75 105.573 103.75 100.003C103.75 94.4336 101.538 89.0922 97.5993 85.1539C93.661 81.2157 88.3195 79.0032 82.75 79.0032C77.1805 79.0032 71.839 81.2157 67.9007 85.1539C63.9625 89.0922 61.75 94.4336 61.75 100.003Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 2.5,
    width: 295,
    height: 164,
    rx: 4,
    transform: "rotate(90 166.5 2.5)",
    stroke: "#D6AF66",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup491);
export default __webpack_public_path__ + "static/media/Group 49 (1).e5ac1934ff5afc99e9a0196fad309c1d.svg";
export { ForwardRef as ReactComponent };